<div class="content-card">
  <div class="card-inner">
    <p-fluid>
      <div class="font-semibold text-xl mb-4 module-name">Client Package Assignment List</div>

      <p-table #dt [value]="viewModel.filteredMappings()" [rows]="10" [paginator]="true"
        [globalFilterFields]="['client.name','package.packageName','startDate','expirationDate']"
        [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" dataKey="id"
        currentPageReportField="Showing {first} to {last} of {totalRecords} mappings" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,20,30]">
        <ng-template #caption>
          <div class="flex flex-col justify-between">
            <div class="flex justify-between gap-4 w-full">
              <div class="flex flex-col flex-1">
                <label class="block font-medium mb-2">Client</label>
                <p-select [options]="viewModel.clientList" optionLabel="name" optionValue="code"
                  [ngModel]="viewModel.selectedClientId()" [filter]="true" placeholder="Filter by Client"
                  [showClear]="!!viewModel.selectedClientId()"
                  (ngModelChange)="viewModel.selectedClientId.set($event)"></p-select>
              </div>
              <div class="flex flex-col flex-1">
                <label class="block font-medium mb-2">Package</label>
                <p-select [options]="viewModel.packageList" optionLabel="name" optionValue="code"
                  [ngModel]="viewModel.selectedPackageId()" [filter]="true" placeholder="Filter by Package"
                  [showClear]="!!viewModel.selectedPackageId()"
                  (ngModelChange)="viewModel.selectedPackageId.set($event)"></p-select>
              </div>
            </div>

            <div class="flex flex-col items-end gap-3 flex-1 mt-4">
              <div class="flex gap-2">
                <p-button label="Add" icon="pi pi-plus" severity="info" (click)="viewModel.openNew()" />
              </div>
            </div>
          </div>
          <div class="flex items-center justify-between mt-4">
            <h5 class="m-0"></h5>
            <p-iconfield>
              <p-inputicon styleClass="pi pi-search" />
              <input pInputText type="text" (input)="viewModel.onGlobalFilter(dt, $event)" placeholder="Search..." />
            </p-iconfield>
          </div>
        </ng-template>

        <ng-template #header>
          <tr>
            <th pSortableColumn="client.name" style="min-width:16rem">Client<p-sortIcon field="client.name" /></th>
            <th pSortableColumn="package.packageName" style="min-width:16rem">Package<p-sortIcon field="package.packageName" /></th>
            <th pSortableColumn="startDate" style="min-width:12rem">Start Date<p-sortIcon field="startDate" /></th>
            <th pSortableColumn="expirationDate" style="min-width:12rem">Expiration Date<p-sortIcon
                field="expirationDate" /></th>
            <th style="width: 12rem">Action</th>
          </tr>
        </ng-template>

        <ng-template #body let-row>
          <tr>
            <td style="min-width:16rem">
              {{ row.client?.name || '-' }}
              <span *ngIf="viewModel.hasIncompleteAuthProfiles(row.clientId)"
                class="ml-2 text-orange-500 text-xs font-medium"
                pTooltip="Some authentication profiles need credentials to be updated" tooltipPosition="top">
                <i class="pi pi-exclamation-triangle"></i> Incomplete
              </span>
            </td>
            <td style="min-width:16rem">{{ row.package?.packageName || '-' }}</td>
            <td style="min-width:12rem">{{ row.startDate ? (row.startDate | date:'MM/dd/yyyy') : '-' }}</td>
            <td style="min-width:12rem">{{ row.expirationDate ? (row.expirationDate | date:'MM/dd/yyyy') : '-' }}</td>
            <td style="width: 12rem">
              <p-button icon="pi pi-pencil" severity="info" [rounded]="true" [outlined]="true" [raised]="true"
                (click)="viewModel.editMapping(row)" pTooltip="Edit" tooltipPosition="top" class="mr-2" />
              <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true" [raised]="true"
                (onClick)="viewModel.deleteMapping(row)" pTooltip="Delete" tooltipPosition="top" />
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td colspan="5" class="noData">No mappings found.</td>
          </tr>
        </ng-template>
      </p-table>

      <p-dialog [visible]="viewModel.dialogVisible()" (visibleChange)="viewModel.dialogVisible.set($event)"
        [appendTo]="'body'" [style]="{ width: '520px' }" [contentStyle]="{ overflow: 'visible' }"
        [header]="viewModel.isEdit() ? 'Edit Client Package Assignment' : 'Create Client Package Assignment'" [modal]="true"
        [dismissableMask]="false" [blockScroll]="true" [draggable]="false"
        styleClass="module-name client-package-dialog">
        <ng-template #content>
          <form class="p-fluid" autocomplete="off" [formGroup]="viewModel.mappingForm">
            <div class="grid grid-cols-1 gap-4">
              <div class="field">
                <label class="block font-medium mb-2">Client <span class="text-red-500">*</span></label>
                <p-select [options]="viewModel.clientList" optionLabel="name" optionValue="code"
                  formControlName="clientId" placeholder="Select Client" [showClear]="!viewModel.isEdit()" [required]="true"
                  [ariaRequired]="true" [disabled]="viewModel.isEdit()"
                  [ngClass]="{'p-invalid': viewModel.mappingForm.get('clientId')?.invalid && viewModel.mappingForm.get('clientId')?.touched}"
                  class="w-full" [style]="{'width':'100%'}"></p-select>
              </div>
              <div class="field">
                <label class="block font-medium mb-2">Package <span class="text-red-500">*</span></label>
                <p-select [options]="viewModel.packageList" optionLabel="name" optionValue="code"
                  formControlName="packageId" placeholder="Select Package" [showClear]="!viewModel.isEdit()" [required]="true"
                  [ariaRequired]="true" [disabled]="viewModel.isEdit()"
                  [ngClass]="{'p-invalid': viewModel.mappingForm.get('packageId')?.invalid && viewModel.mappingForm.get('packageId')?.touched}"
                  class="w-full" [style]="{'width':'100%'}"></p-select>
              </div>
              <div class="field">
                <label class="block font-medium mb-2">Start Date <span class="text-red-500">*</span></label>
                <p-datepicker formControlName="startDate" inputId="startDate" [showIcon]="true" [appendTo]="'body'"
                  [required]="true" [ariaRequired]="true" [minDate]="viewModel.minStartDate()"
                  [ngClass]="{'p-invalid': viewModel.mappingForm.get('startDate')?.invalid && viewModel.mappingForm.get('startDate')?.touched}"
                  class="w-full" [style]="{'width':'100%'}"></p-datepicker>
              </div>
              <div class="field">
                <label class="block font-medium mb-2">Expiration Date <span class="text-red-500">*</span></label>
                <p-datepicker formControlName="expirationDate" inputId="expirationDate" [showIcon]="true"
                  [appendTo]="'body'" [required]="true" [ariaRequired]="true" [minDate]="viewModel.minExpirationDate()"
                  [disabled]="viewModel.expirationDisabled()"
                  [ngClass]="{'p-invalid': viewModel.mappingForm.get('expirationDate')?.invalid && viewModel.mappingForm.get('expirationDate')?.touched}"
                  class="w-full" [style]="{'width':'100%'}"></p-datepicker>
              </div>
            </div>
          </form>
        </ng-template>
        <ng-template #footer class="mt-2">
          <p-button label="Cancel" icon="pi pi-times" severity="warn" (click)="viewModel.hideDialog()"></p-button>
          <p-button [label]="viewModel.isEdit() ? 'Update' : 'Submit'" icon="pi pi-check" severity="success" 
                    [disabled]="viewModel.isSubmitDisabled()" 
                    (click)="viewModel.submitDialog()"></p-button>
        </ng-template>
      </p-dialog>

    </p-fluid>

    <p-confirmDialog [style]="{ width: '450px' }" styleClass="custom-confirm-dialog"></p-confirmDialog>
  </div>
</div>